
import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
},
data () {
},
beforeCreate: function () {
this.querydata = common.getPower()
},
activated: function () {
this.$vux.alert.show({
title: '提示',
content: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您尚无查询权限，请扫描相应图书封面二维码，获取权限！',
onHide () {
window.close()
}

})
},
created: function () {
}
}



// WEBPACK FOOTER //
// ./src/components/NoPower.vue